import { useState } from 'react';
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterInput } from '../shared/FilterInput';

export const BannerFamiliaTable = ({ familias, loading, selectedId, onSelect, disabled }) => {
    const [collapsed, setCollapsed] = useState(true);
    const selected = selectedId != null ? familias.find(f => String(f.id) === String(selectedId)) || null : null;

    const handleSelection = (e) => {
        onSelect(e.value?.id || null);
    };

    const headerTemplate = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const hasSelection = selectedId != null;
        return (
            <div className="flex align-items-center justify-content-between w-full cursor-pointer" onClick={options.onTogglerClick}>
                <div className="flex align-items-center ">
                    <span className="font-bold text-lg">Familia</span>
                    {hasSelection && <span className="text-sm text-green-600 font-medium">({selected?.nombre})</span>}
                </div>
                <span className={`${toggleIcon} text-500`} />
            </div>
        );
    };

    return (
        <Panel
            header="Familia"
            toggleable
            collapsed={collapsed}
            onToggle={(e) => setCollapsed(e.value)}
            headerTemplate={headerTemplate}
            className={selectedId != null ? 'border-green-300' : ''}
        >
            <BannerFamiliaTableContent
                familias={familias}
                loading={loading}
                selected={selected}
                onSelectionChange={handleSelection}
                disabled={disabled}
            />
        </Panel>
    );
};

const BannerFamiliaTableContent = ({ familias, loading, selected, onSelectionChange, disabled }) => {
    const rows = [{ id: null, nombre: '— Sin selección —' }, ...familias];

    return (
        <DataTable
            value={rows}
            selectionMode="single"
            selection={selected}
            onSelectionChange={onSelectionChange}
            dataKey="id"
            paginator
            rows={6}
            rowsPerPageOptions={[6, 10, 25]}
            scrollable
            scrollHeight="200px"
            loading={loading}
            emptyMessage="Sin familias"
            filterDisplay="row"
            filter
            tableStyle={{ minWidth: '100%' }}
            disabled={disabled}
        >
            <Column field="id" header="ID" sortable style={{ width: '20%' }} filter filterElement={FilterInput} bodyStyle={{ textAlign: 'center' }} />
            <Column field="nombre" header="Nombre" sortable style={{ width: '80%' }} filter filterElement={FilterInput} />
        </DataTable>
    );
};
